export default "__VITE_ASSET__CkAcoNJt__"